/** Auto-synced from backend core.airport_timezone._IATA_TZ */
export const AIRPORT_TZ: Record<string, string> = {
  "SVO": "Europe/Moscow",
  "DME": "Europe/Moscow",
  "VKO": "Europe/Moscow",
  "ZIA": "Europe/Moscow",
  "LED": "Europe/Moscow",
  "AER": "Europe/Moscow",
  "KRR": "Europe/Moscow",
  "ROV": "Europe/Moscow",
  "KUF": "Europe/Samara",
  "KZN": "Europe/Moscow",
  "GOJ": "Europe/Moscow",
  "SVX": "Asia/Yekaterinburg",
  "CEK": "Asia/Yekaterinburg",
  "UFA": "Asia/Yekaterinburg",
  "OMS": "Asia/Omsk",
  "OVB": "Asia/Novosibirsk",
  "TOF": "Asia/Tomsk",
  "KEJ": "Asia/Novokuznetsk",
  "IKT": "Asia/Irkutsk",
  "UUD": "Asia/Irkutsk",
  "YKS": "Asia/Yakutsk",
  "VVO": "Asia/Vladivostok",
  "KHV": "Asia/Vladivostok",
  "PKC": "Asia/Kamchatka",
  "SGC": "Asia/Yekaterinburg",
  "TJM": "Asia/Yekaterinburg",
  "NUX": "Asia/Yekaterinburg",
  "NOJ": "Asia/Yekaterinburg",
  "MRV": "Europe/Moscow",
  "MCX": "Europe/Moscow",
  "ASF": "Europe/Astrakhan",
  "AAQ": "Europe/Moscow",
  "SIP": "Europe/Simferopol",
  "BKK": "Asia/Bangkok",
  "DMK": "Asia/Bangkok",
  "HKT": "Asia/Bangkok",
  "CNX": "Asia/Bangkok",
  "UTP": "Asia/Bangkok",
  "SIN": "Asia/Singapore",
  "KUL": "Asia/Kuala_Lumpur",
  "CGK": "Asia/Jakarta",
  "DPS": "Asia/Makassar",
  "SGN": "Asia/Ho_Chi_Minh",
  "HAN": "Asia/Ho_Chi_Minh",
  "MNL": "Asia/Manila",
  "RGN": "Asia/Yangon",
  "MCT": "Asia/Muscat",
  "DXB": "Asia/Dubai",
  "AUH": "Asia/Dubai",
  "SHJ": "Asia/Dubai",
  "DOH": "Asia/Qatar",
  "BAH": "Asia/Bahrain",
  "RUH": "Asia/Riyadh",
  "JED": "Asia/Riyadh",
  "AMM": "Asia/Amman",
  "TLV": "Asia/Jerusalem",
  "IST": "Europe/Istanbul",
  "SAW": "Europe/Istanbul",
  "AYT": "Europe/Istanbul",
  "ESB": "Europe/Istanbul",
  "LHR": "Europe/London",
  "LGW": "Europe/London",
  "STN": "Europe/London",
  "CDG": "Europe/Paris",
  "ORY": "Europe/Paris",
  "FRA": "Europe/Berlin",
  "MUC": "Europe/Berlin",
  "BER": "Europe/Berlin",
  "AMS": "Europe/Amsterdam",
  "BRU": "Europe/Brussels",
  "MAD": "Europe/Madrid",
  "BCN": "Europe/Madrid",
  "FCO": "Europe/Rome",
  "MXP": "Europe/Rome",
  "VIE": "Europe/Vienna",
  "PRG": "Europe/Prague",
  "WAW": "Europe/Warsaw",
  "KRK": "Europe/Warsaw",
  "BUD": "Europe/Budapest",
  "ATH": "Europe/Athens",
  "HEL": "Europe/Helsinki",
  "ARN": "Europe/Stockholm",
  "CPH": "Europe/Copenhagen",
  "OSL": "Europe/Oslo",
  "ZRH": "Europe/Zurich",
  "GVA": "Europe/Zurich",
  "LIS": "Europe/Lisbon",
  "DUB": "Europe/Dublin",
  "RIX": "Europe/Riga",
  "TLL": "Europe/Tallinn",
  "VNO": "Europe/Vilnius",
  "MSQ": "Europe/Minsk",
  "KBP": "Europe/Kyiv",
  "IEV": "Europe/Kyiv",
  "ODS": "Europe/Kyiv",
  "TBS": "Asia/Tbilisi",
  "GYD": "Asia/Baku",
  "EVN": "Asia/Yerevan",
  "ALA": "Asia/Almaty",
  "NQZ": "Asia/Almaty",
  "TAS": "Asia/Tashkent",
  "NRT": "Asia/Tokyo",
  "HND": "Asia/Tokyo",
  "ICN": "Asia/Seoul",
  "GMP": "Asia/Seoul",
  "PEK": "Asia/Shanghai",
  "PKX": "Asia/Shanghai",
  "PVG": "Asia/Shanghai",
  "TFU": "Asia/Shanghai",
  "CTU": "Asia/Shanghai",
  "CAN": "Asia/Shanghai",
  "HKG": "Asia/Hong_Kong",
  "TPE": "Asia/Taipei",
  "JFK": "America/New_York",
  "EWR": "America/New_York",
  "LGA": "America/New_York",
  "BOS": "America/New_York",
  "ORD": "America/Chicago",
  "ATL": "America/New_York",
  "MIA": "America/New_York",
  "DFW": "America/Chicago",
  "DEN": "America/Denver",
  "LAX": "America/Los_Angeles",
  "SFO": "America/Los_Angeles",
  "SEA": "America/Los_Angeles",
  "YVR": "America/Vancouver",
  "YYZ": "America/Toronto",
  "YUL": "America/Toronto",
  "MEX": "America/Mexico_City",
  "GRU": "America/Sao_Paulo",
  "GIG": "America/Sao_Paulo",
  "EZE": "America/Argentina/Buenos_Aires",
  "CAI": "Africa/Cairo",
  "CMN": "Africa/Casablanca",
  "JNB": "Africa/Johannesburg",
  "CPT": "Africa/Johannesburg",
  "NBO": "Africa/Nairobi",
  "ADD": "Africa/Addis_Ababa",
  "SYD": "Australia/Sydney",
  "MEL": "Australia/Melbourne",
  "BNE": "Australia/Brisbane",
  "PER": "Australia/Perth",
  "AKL": "Pacific/Auckland"
} as const;
